// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"7817b875","43":"0b6a4b33","179":"04984531","181":"f5b18c09","211":"b133f80c","246":"fcaca572","453":"3585c802","517":"8fa87960","584":"e4b6b3d4","668":"bbf27e55","723":"a693b9b0","919":"fa9fd093","975":"3444d0bc"}[chunkId] + ".chunk.js";
};